export const configs = {
  apiURL: `${process.env.REACT_APP_API_URL}/api`,
  socketURL: process.env.REACT_APP_API_URL,
};
